import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import Home from "./pages/Home";
import Casa from "./pages/Casa";
import Reservas from "./pages/Reservas";
import Contato from "./pages/Contato";
import NossaHistoria from "./pages/NossaHistoria";

import PrivateRoutes from "./routes/PrivateRoutes";

import Dashboard from "./admin/Dashboard";
import Config from "./admin/Config";
import History from "./admin/History";
import Login from "./admin/Login";
import Mensagens from "./admin/Mensagens";

import LoaderScreen from "./components/LoaderScreen";

// MUI Date Picker Provider
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Router>
        {/* Loader overlay */}
        {loading && <LoaderScreen />}

        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/casa" element={<Casa />} />
            <Route path="/reservas" element={<Reservas />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/nossa-historia" element={<NossaHistoria />} />

            <Route path="/login" element={<Login />} />

            <Route
              path="/admin/dashboard"
              element={
                <PrivateRoutes>
                  <Dashboard />
                </PrivateRoutes>
              }
            />
            <Route
              path="/admin/reservas"
              element={
                <PrivateRoutes>
                  <History />
                </PrivateRoutes>
              }
            />
            <Route
              path="/admin/config"
              element={
                <PrivateRoutes>
                  <Config />
                </PrivateRoutes>
              }
            />
            <Route
              path="/admin/mensagens"
              element={
                <PrivateRoutes>
                  <Mensagens />
                </PrivateRoutes>
              }
            />
          </Routes>
        </div>
      </Router>
    </LocalizationProvider>
  );
}

export default App;